module.exports = __webpack_public_path__ + "ca3b1870ee34a61de7d30c6a156e2830.jpg";